/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * agora/v1/rbac.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  CreateCustomRoleParams,
  CurrentUserPermissionsParams,
  DeleteCustomRole200,
  ListCurrentUserPendingInvitationsParams,
  ListCustomRolesParams,
  ListOrganizationRolesParams,
  ListOrganizationUserInvitesParams,
  ListWorkspacePermissionsParams,
  ListWorkspaceRolesParams,
  ListWorkspaceUserInvitesParams,
  RBACServiceAcceptInvitationBody,
  RBACServiceApproveAccessRequestBody,
  RBACServiceAssignOrganizationUserRolesBody,
  RBACServiceAssignWorkspaceUserRolesBody,
  RBACServiceDeclineInvitationBody,
  RBACServiceDenyAccessRequestBody,
  RBACServiceInviteOrganizationUsersBody,
  RBACServiceInviteWorkspaceUsersBody,
  RBACServiceRemoveOrganizationUsersBody,
  RBACServiceRemoveWorkspaceUsersBody,
  RBACServiceRequestOrganizationAccessBody,
  RBACServiceRequestWorkspaceAccessBody,
  RBACServiceRevokeOrganizationUserInviteBody,
  RBACServiceRevokeWorkspaceUserInviteBody,
  RpcStatus,
  UpdateCustomRoleBody,
  V1AcceptInvitationResponse,
  V1AddRoleTemplatePermissionsRequest,
  V1AddRoleTemplatePermissionsResponse,
  V1AssignOrganizationUserRolesResponse,
  V1AssignWorkspaceUserRolesResponse,
  V1AuthorizationSnapshot,
  V1BackfillPermissionsForRoleTemplateRequest,
  V1BackfillPermissionsForRoleTemplateResponse,
  V1BatchGetUserAuthorizationVersionsRequest,
  V1BatchGetUserAuthorizationVersionsResponse,
  V1CreatePermissionTemplateRequest,
  V1CreateRoleTemplateRequest,
  V1CurrentUserOrganizationPermissionsResponse,
  V1CurrentUserOrganizationRolesResponse,
  V1CurrentUserPermissionsResponse,
  V1CurrentUserWorkspacePermissionsResponse,
  V1CurrentUserWorkspaceRolesResponse,
  V1CustomRole,
  V1DenyAccessRequestResponse,
  V1GetAuthorizationSnapshotRequest,
  V1GetGlobalSchemaVersionRequest,
  V1GetPermissionTemplateRequest,
  V1GetRoleTemplateRequest,
  V1GlobalSchemaVersion,
  V1Invitation,
  V1InviteOrganizationUsersResponse,
  V1InviteWorkspaceUsersResponse,
  V1ListCurrentUserPendingInvitationsResponse,
  V1ListCustomRolesResponse,
  V1ListOrganizationRolesResponse,
  V1ListOrganizationUserInvitesResponse,
  V1ListPermissionTemplatesRequest,
  V1ListPermissionTemplatesResponse,
  V1ListPermissionsRequest,
  V1ListPermissionsResponse,
  V1ListRoleTemplatesRequest,
  V1ListRoleTemplatesResponse,
  V1ListRolesRequest,
  V1ListRolesResponse,
  V1ListUserRolesRequest,
  V1ListUserRolesResponse,
  V1ListWorkspacePermissionsResponse,
  V1ListWorkspaceRolesResponse,
  V1ListWorkspaceUserInvitesResponse,
  V1PermissionTemplate,
  V1RemoveOrganizationUsersResponse,
  V1RemoveWorkspaceUsersResponse,
  V1RevokeOrganizationUserInviteResponse,
  V1RevokeWorkspaceUserInviteResponse,
  V1RoleTemplate,
  V1UpdatePermissionTemplateRequest,
  V1UpdateRoleTemplateRequest,
} from '../models';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * @summary Adds permission templates to an existing role template.
 */
export const addRoleTemplatePermissions = (
  v1AddRoleTemplatePermissionsRequest: V1AddRoleTemplatePermissionsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AddRoleTemplatePermissionsResponse>> => {
  return axios.default.post(
    `/agora.v1.RBACService/AddRoleTemplatePermissions`,
    v1AddRoleTemplatePermissionsRequest,
    options,
  );
};

export const getAddRoleTemplatePermissionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addRoleTemplatePermissions>>,
    TError,
    { data: V1AddRoleTemplatePermissionsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addRoleTemplatePermissions>>,
  TError,
  { data: V1AddRoleTemplatePermissionsRequest },
  TContext
> => {
  const mutationKey = ['addRoleTemplatePermissions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addRoleTemplatePermissions>>,
    { data: V1AddRoleTemplatePermissionsRequest }
  > = props => {
    const { data } = props ?? {};

    return addRoleTemplatePermissions(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddRoleTemplatePermissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof addRoleTemplatePermissions>>
>;
export type AddRoleTemplatePermissionsMutationBody =
  V1AddRoleTemplatePermissionsRequest;
export type AddRoleTemplatePermissionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Adds permission templates to an existing role template.
 */
export const useAddRoleTemplatePermissions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addRoleTemplatePermissions>>,
      TError,
      { data: V1AddRoleTemplatePermissionsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addRoleTemplatePermissions>>,
  TError,
  { data: V1AddRoleTemplatePermissionsRequest },
  TContext
> => {
  const mutationOptions = getAddRoleTemplatePermissionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Backfills newly-added permission templates to all existing concrete roles
derived from the given role template. Called after AddRoleTemplatePermissions
to propagate template changes to already-provisioned organizations/workspaces.
Idempotent: re-running on already-backfilled roles is a no-op.
 */
export const backfillPermissionsForRoleTemplate = (
  v1BackfillPermissionsForRoleTemplateRequest: V1BackfillPermissionsForRoleTemplateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BackfillPermissionsForRoleTemplateResponse>> => {
  return axios.default.post(
    `/agora.v1.RBACService/BackfillPermissionsForRoleTemplate`,
    v1BackfillPermissionsForRoleTemplateRequest,
    options,
  );
};

export const getBackfillPermissionsForRoleTemplateMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backfillPermissionsForRoleTemplate>>,
    TError,
    { data: V1BackfillPermissionsForRoleTemplateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backfillPermissionsForRoleTemplate>>,
  TError,
  { data: V1BackfillPermissionsForRoleTemplateRequest },
  TContext
> => {
  const mutationKey = ['backfillPermissionsForRoleTemplate'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backfillPermissionsForRoleTemplate>>,
    { data: V1BackfillPermissionsForRoleTemplateRequest }
  > = props => {
    const { data } = props ?? {};

    return backfillPermissionsForRoleTemplate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackfillPermissionsForRoleTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof backfillPermissionsForRoleTemplate>>
>;
export type BackfillPermissionsForRoleTemplateMutationBody =
  V1BackfillPermissionsForRoleTemplateRequest;
export type BackfillPermissionsForRoleTemplateMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Backfills newly-added permission templates to all existing concrete roles
derived from the given role template. Called after AddRoleTemplatePermissions
to propagate template changes to already-provisioned organizations/workspaces.
Idempotent: re-running on already-backfilled roles is a no-op.
 */
export const useBackfillPermissionsForRoleTemplate = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof backfillPermissionsForRoleTemplate>>,
      TError,
      { data: V1BackfillPermissionsForRoleTemplateRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof backfillPermissionsForRoleTemplate>>,
  TError,
  { data: V1BackfillPermissionsForRoleTemplateRequest },
  TContext
> => {
  const mutationOptions =
    getBackfillPermissionsForRoleTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Returns authorization versions for specified users, useful for cache invalidation.
 */
export const batchGetUserAuthorizationVersions = (
  v1BatchGetUserAuthorizationVersionsRequest: V1BatchGetUserAuthorizationVersionsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchGetUserAuthorizationVersionsResponse>> => {
  return axios.default.post(
    `/agora.v1.RBACService/BatchGetUserAuthorizationVersions`,
    v1BatchGetUserAuthorizationVersionsRequest,
    options,
  );
};

export const getBatchGetUserAuthorizationVersionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchGetUserAuthorizationVersions>>,
    TError,
    { data: V1BatchGetUserAuthorizationVersionsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchGetUserAuthorizationVersions>>,
  TError,
  { data: V1BatchGetUserAuthorizationVersionsRequest },
  TContext
> => {
  const mutationKey = ['batchGetUserAuthorizationVersions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchGetUserAuthorizationVersions>>,
    { data: V1BatchGetUserAuthorizationVersionsRequest }
  > = props => {
    const { data } = props ?? {};

    return batchGetUserAuthorizationVersions(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchGetUserAuthorizationVersionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchGetUserAuthorizationVersions>>
>;
export type BatchGetUserAuthorizationVersionsMutationBody =
  V1BatchGetUserAuthorizationVersionsRequest;
export type BatchGetUserAuthorizationVersionsMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Returns authorization versions for specified users, useful for cache invalidation.
 */
export const useBatchGetUserAuthorizationVersions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchGetUserAuthorizationVersions>>,
      TError,
      { data: V1BatchGetUserAuthorizationVersionsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchGetUserAuthorizationVersions>>,
  TError,
  { data: V1BatchGetUserAuthorizationVersionsRequest },
  TContext
> => {
  const mutationOptions =
    getBatchGetUserAuthorizationVersionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Creates a new permission template.
 */
export const createPermissionTemplate = (
  v1CreatePermissionTemplateRequest: V1CreatePermissionTemplateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PermissionTemplate>> => {
  return axios.default.post(
    `/agora.v1.RBACService/CreatePermissionTemplate`,
    v1CreatePermissionTemplateRequest,
    options,
  );
};

export const getCreatePermissionTemplateMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPermissionTemplate>>,
    TError,
    { data: V1CreatePermissionTemplateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPermissionTemplate>>,
  TError,
  { data: V1CreatePermissionTemplateRequest },
  TContext
> => {
  const mutationKey = ['createPermissionTemplate'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPermissionTemplate>>,
    { data: V1CreatePermissionTemplateRequest }
  > = props => {
    const { data } = props ?? {};

    return createPermissionTemplate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePermissionTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPermissionTemplate>>
>;
export type CreatePermissionTemplateMutationBody =
  V1CreatePermissionTemplateRequest;
export type CreatePermissionTemplateMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new permission template.
 */
export const useCreatePermissionTemplate = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPermissionTemplate>>,
      TError,
      { data: V1CreatePermissionTemplateRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPermissionTemplate>>,
  TError,
  { data: V1CreatePermissionTemplateRequest },
  TContext
> => {
  const mutationOptions = getCreatePermissionTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Creates a new role template with associated permission templates.
 */
export const createRoleTemplate = (
  v1CreateRoleTemplateRequest: V1CreateRoleTemplateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RoleTemplate>> => {
  return axios.default.post(
    `/agora.v1.RBACService/CreateRoleTemplate`,
    v1CreateRoleTemplateRequest,
    options,
  );
};

export const getCreateRoleTemplateMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRoleTemplate>>,
    TError,
    { data: V1CreateRoleTemplateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRoleTemplate>>,
  TError,
  { data: V1CreateRoleTemplateRequest },
  TContext
> => {
  const mutationKey = ['createRoleTemplate'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRoleTemplate>>,
    { data: V1CreateRoleTemplateRequest }
  > = props => {
    const { data } = props ?? {};

    return createRoleTemplate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRoleTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRoleTemplate>>
>;
export type CreateRoleTemplateMutationBody = V1CreateRoleTemplateRequest;
export type CreateRoleTemplateMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new role template with associated permission templates.
 */
export const useCreateRoleTemplate = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRoleTemplate>>,
      TError,
      { data: V1CreateRoleTemplateRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createRoleTemplate>>,
  TError,
  { data: V1CreateRoleTemplateRequest },
  TContext
> => {
  const mutationOptions = getCreateRoleTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Equivalent in content to calling ListPermissionTemplates, ListPermissions
(unfiltered) and GetGlobalSchemaVersion, but without the time-of-check /
time-of-use gap between them: fetched separately, the data can change
between calls and be stamped with a version it does not correspond to.
Clients that gate a cache on schema_version (e.g. Rakshak's PAT allow-list,
where pat_eligible is a revocation mechanism and a stale allow-list is a
fail-open) must use this RPC rather than composing the three.
 * @summary Returns the permission templates, the permission catalog, and the global
schema version they correspond to, all read from a single consistent
database snapshot.
 */
export const getAuthorizationSnapshot = (
  v1GetAuthorizationSnapshotRequest: V1GetAuthorizationSnapshotRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AuthorizationSnapshot>> => {
  return axios.default.post(
    `/agora.v1.RBACService/GetAuthorizationSnapshot`,
    v1GetAuthorizationSnapshotRequest,
    options,
  );
};

export const getGetAuthorizationSnapshotMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAuthorizationSnapshot>>,
    TError,
    { data: V1GetAuthorizationSnapshotRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAuthorizationSnapshot>>,
  TError,
  { data: V1GetAuthorizationSnapshotRequest },
  TContext
> => {
  const mutationKey = ['getAuthorizationSnapshot'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAuthorizationSnapshot>>,
    { data: V1GetAuthorizationSnapshotRequest }
  > = props => {
    const { data } = props ?? {};

    return getAuthorizationSnapshot(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAuthorizationSnapshotMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAuthorizationSnapshot>>
>;
export type GetAuthorizationSnapshotMutationBody =
  V1GetAuthorizationSnapshotRequest;
export type GetAuthorizationSnapshotMutationError = AxiosError<RpcStatus>;

/**
 * @summary Returns the permission templates, the permission catalog, and the global
schema version they correspond to, all read from a single consistent
database snapshot.
 */
export const useGetAuthorizationSnapshot = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAuthorizationSnapshot>>,
      TError,
      { data: V1GetAuthorizationSnapshotRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getAuthorizationSnapshot>>,
  TError,
  { data: V1GetAuthorizationSnapshotRequest },
  TContext
> => {
  const mutationOptions = getGetAuthorizationSnapshotMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Returns the global schema version, used for cache invalidation of global
permission template metadata (e.g., PAT allow-list).
 */
export const getGlobalSchemaVersion = (
  v1GetGlobalSchemaVersionRequest: V1GetGlobalSchemaVersionRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GlobalSchemaVersion>> => {
  return axios.default.post(
    `/agora.v1.RBACService/GetGlobalSchemaVersion`,
    v1GetGlobalSchemaVersionRequest,
    options,
  );
};

export const getGetGlobalSchemaVersionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getGlobalSchemaVersion>>,
    TError,
    { data: V1GetGlobalSchemaVersionRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getGlobalSchemaVersion>>,
  TError,
  { data: V1GetGlobalSchemaVersionRequest },
  TContext
> => {
  const mutationKey = ['getGlobalSchemaVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getGlobalSchemaVersion>>,
    { data: V1GetGlobalSchemaVersionRequest }
  > = props => {
    const { data } = props ?? {};

    return getGlobalSchemaVersion(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetGlobalSchemaVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof getGlobalSchemaVersion>>
>;
export type GetGlobalSchemaVersionMutationBody =
  V1GetGlobalSchemaVersionRequest;
export type GetGlobalSchemaVersionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Returns the global schema version, used for cache invalidation of global
permission template metadata (e.g., PAT allow-list).
 */
export const useGetGlobalSchemaVersion = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getGlobalSchemaVersion>>,
      TError,
      { data: V1GetGlobalSchemaVersionRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getGlobalSchemaVersion>>,
  TError,
  { data: V1GetGlobalSchemaVersionRequest },
  TContext
> => {
  const mutationOptions = getGetGlobalSchemaVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets a permission template.
 */
export const getPermissionTemplate = (
  v1GetPermissionTemplateRequest: V1GetPermissionTemplateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PermissionTemplate>> => {
  return axios.default.post(
    `/agora.v1.RBACService/GetPermissionTemplate`,
    v1GetPermissionTemplateRequest,
    options,
  );
};

export const getGetPermissionTemplateMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPermissionTemplate>>,
    TError,
    { data: V1GetPermissionTemplateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPermissionTemplate>>,
  TError,
  { data: V1GetPermissionTemplateRequest },
  TContext
> => {
  const mutationKey = ['getPermissionTemplate'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPermissionTemplate>>,
    { data: V1GetPermissionTemplateRequest }
  > = props => {
    const { data } = props ?? {};

    return getPermissionTemplate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPermissionTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof getPermissionTemplate>>
>;
export type GetPermissionTemplateMutationBody = V1GetPermissionTemplateRequest;
export type GetPermissionTemplateMutationError = AxiosError<RpcStatus>;

/**
 * @summary Gets a permission template.
 */
export const useGetPermissionTemplate = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getPermissionTemplate>>,
      TError,
      { data: V1GetPermissionTemplateRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getPermissionTemplate>>,
  TError,
  { data: V1GetPermissionTemplateRequest },
  TContext
> => {
  const mutationOptions = getGetPermissionTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets a role template.
 */
export const getRoleTemplate = (
  v1GetRoleTemplateRequest: V1GetRoleTemplateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RoleTemplate>> => {
  return axios.default.post(
    `/agora.v1.RBACService/GetRoleTemplate`,
    v1GetRoleTemplateRequest,
    options,
  );
};

export const getGetRoleTemplateMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRoleTemplate>>,
    TError,
    { data: V1GetRoleTemplateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRoleTemplate>>,
  TError,
  { data: V1GetRoleTemplateRequest },
  TContext
> => {
  const mutationKey = ['getRoleTemplate'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRoleTemplate>>,
    { data: V1GetRoleTemplateRequest }
  > = props => {
    const { data } = props ?? {};

    return getRoleTemplate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRoleTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof getRoleTemplate>>
>;
export type GetRoleTemplateMutationBody = V1GetRoleTemplateRequest;
export type GetRoleTemplateMutationError = AxiosError<RpcStatus>;

/**
 * @summary Gets a role template.
 */
export const useGetRoleTemplate = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRoleTemplate>>,
      TError,
      { data: V1GetRoleTemplateRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRoleTemplate>>,
  TError,
  { data: V1GetRoleTemplateRequest },
  TContext
> => {
  const mutationOptions = getGetRoleTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists all permission templates in the system.
Returns global template definitions regardless of user role assignments.
Used by Rakshak to build the PAT allow-list from template-level metadata.
 */
export const listPermissionTemplates = (
  v1ListPermissionTemplatesRequest: V1ListPermissionTemplatesRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListPermissionTemplatesResponse>> => {
  return axios.default.post(
    `/agora.v1.RBACService/ListPermissionTemplates`,
    v1ListPermissionTemplatesRequest,
    options,
  );
};

export const getListPermissionTemplatesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listPermissionTemplates>>,
    TError,
    { data: V1ListPermissionTemplatesRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listPermissionTemplates>>,
  TError,
  { data: V1ListPermissionTemplatesRequest },
  TContext
> => {
  const mutationKey = ['listPermissionTemplates'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listPermissionTemplates>>,
    { data: V1ListPermissionTemplatesRequest }
  > = props => {
    const { data } = props ?? {};

    return listPermissionTemplates(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListPermissionTemplatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof listPermissionTemplates>>
>;
export type ListPermissionTemplatesMutationBody =
  V1ListPermissionTemplatesRequest;
export type ListPermissionTemplatesMutationError = AxiosError<RpcStatus>;

/**
 * @summary Lists all permission templates in the system.
Returns global template definitions regardless of user role assignments.
Used by Rakshak to build the PAT allow-list from template-level metadata.
 */
export const useListPermissionTemplates = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listPermissionTemplates>>,
      TError,
      { data: V1ListPermissionTemplatesRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listPermissionTemplates>>,
  TError,
  { data: V1ListPermissionTemplatesRequest },
  TContext
> => {
  const mutationOptions = getListPermissionTemplatesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists all available permissions in the system.
 */
export const listPermissions = (
  v1ListPermissionsRequest: V1ListPermissionsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListPermissionsResponse>> => {
  return axios.default.post(
    `/agora.v1.RBACService/ListPermissions`,
    v1ListPermissionsRequest,
    options,
  );
};

export const getListPermissionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listPermissions>>,
    TError,
    { data: V1ListPermissionsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listPermissions>>,
  TError,
  { data: V1ListPermissionsRequest },
  TContext
> => {
  const mutationKey = ['listPermissions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listPermissions>>,
    { data: V1ListPermissionsRequest }
  > = props => {
    const { data } = props ?? {};

    return listPermissions(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListPermissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof listPermissions>>
>;
export type ListPermissionsMutationBody = V1ListPermissionsRequest;
export type ListPermissionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Lists all available permissions in the system.
 */
export const useListPermissions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listPermissions>>,
      TError,
      { data: V1ListPermissionsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listPermissions>>,
  TError,
  { data: V1ListPermissionsRequest },
  TContext
> => {
  const mutationOptions = getListPermissionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists all available role templates in the system.
Returns system-defined role templates that can be assigned at org or workspace level.
 */
export const listRoleTemplates = (
  v1ListRoleTemplatesRequest: V1ListRoleTemplatesRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListRoleTemplatesResponse>> => {
  return axios.default.post(
    `/agora.v1.RBACService/ListRoleTemplates`,
    v1ListRoleTemplatesRequest,
    options,
  );
};

export const getListRoleTemplatesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listRoleTemplates>>,
    TError,
    { data: V1ListRoleTemplatesRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listRoleTemplates>>,
  TError,
  { data: V1ListRoleTemplatesRequest },
  TContext
> => {
  const mutationKey = ['listRoleTemplates'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listRoleTemplates>>,
    { data: V1ListRoleTemplatesRequest }
  > = props => {
    const { data } = props ?? {};

    return listRoleTemplates(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListRoleTemplatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof listRoleTemplates>>
>;
export type ListRoleTemplatesMutationBody = V1ListRoleTemplatesRequest;
export type ListRoleTemplatesMutationError = AxiosError<RpcStatus>;

/**
 * @summary Lists all available role templates in the system.
Returns system-defined role templates that can be assigned at org or workspace level.
 */
export const useListRoleTemplates = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listRoleTemplates>>,
      TError,
      { data: V1ListRoleTemplatesRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listRoleTemplates>>,
  TError,
  { data: V1ListRoleTemplatesRequest },
  TContext
> => {
  const mutationOptions = getListRoleTemplatesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists all the available roles across all organizations and workspaces.
 */
export const listRoles = (
  v1ListRolesRequest: V1ListRolesRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListRolesResponse>> => {
  return axios.default.post(
    `/agora.v1.RBACService/ListRoles`,
    v1ListRolesRequest,
    options,
  );
};

export const getListRolesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listRoles>>,
    TError,
    { data: V1ListRolesRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listRoles>>,
  TError,
  { data: V1ListRolesRequest },
  TContext
> => {
  const mutationKey = ['listRoles'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listRoles>>,
    { data: V1ListRolesRequest }
  > = props => {
    const { data } = props ?? {};

    return listRoles(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof listRoles>>
>;
export type ListRolesMutationBody = V1ListRolesRequest;
export type ListRolesMutationError = AxiosError<RpcStatus>;

/**
 * @summary Lists all the available roles across all organizations and workspaces.
 */
export const useListRoles = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listRoles>>,
      TError,
      { data: V1ListRolesRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listRoles>>,
  TError,
  { data: V1ListRolesRequest },
  TContext
> => {
  const mutationOptions = getListRolesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists user-to-role assignments with optional filtering by scope and user.
 */
export const listUserRoles = (
  v1ListUserRolesRequest: V1ListUserRolesRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListUserRolesResponse>> => {
  return axios.default.post(
    `/agora.v1.RBACService/ListUserRoles`,
    v1ListUserRolesRequest,
    options,
  );
};

export const getListUserRolesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listUserRoles>>,
    TError,
    { data: V1ListUserRolesRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listUserRoles>>,
  TError,
  { data: V1ListUserRolesRequest },
  TContext
> => {
  const mutationKey = ['listUserRoles'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listUserRoles>>,
    { data: V1ListUserRolesRequest }
  > = props => {
    const { data } = props ?? {};

    return listUserRoles(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListUserRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof listUserRoles>>
>;
export type ListUserRolesMutationBody = V1ListUserRolesRequest;
export type ListUserRolesMutationError = AxiosError<RpcStatus>;

/**
 * @summary Lists user-to-role assignments with optional filtering by scope and user.
 */
export const useListUserRoles = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listUserRoles>>,
      TError,
      { data: V1ListUserRolesRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listUserRoles>>,
  TError,
  { data: V1ListUserRolesRequest },
  TContext
> => {
  const mutationOptions = getListUserRolesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates a permission template.
 */
export const updatePermissionTemplate = (
  v1UpdatePermissionTemplateRequest: V1UpdatePermissionTemplateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PermissionTemplate>> => {
  return axios.default.post(
    `/agora.v1.RBACService/UpdatePermissionTemplate`,
    v1UpdatePermissionTemplateRequest,
    options,
  );
};

export const getUpdatePermissionTemplateMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePermissionTemplate>>,
    TError,
    { data: V1UpdatePermissionTemplateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePermissionTemplate>>,
  TError,
  { data: V1UpdatePermissionTemplateRequest },
  TContext
> => {
  const mutationKey = ['updatePermissionTemplate'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePermissionTemplate>>,
    { data: V1UpdatePermissionTemplateRequest }
  > = props => {
    const { data } = props ?? {};

    return updatePermissionTemplate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePermissionTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePermissionTemplate>>
>;
export type UpdatePermissionTemplateMutationBody =
  V1UpdatePermissionTemplateRequest;
export type UpdatePermissionTemplateMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a permission template.
 */
export const useUpdatePermissionTemplate = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePermissionTemplate>>,
      TError,
      { data: V1UpdatePermissionTemplateRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePermissionTemplate>>,
  TError,
  { data: V1UpdatePermissionTemplateRequest },
  TContext
> => {
  const mutationOptions = getUpdatePermissionTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates a role template.
 */
export const updateRoleTemplate = (
  v1UpdateRoleTemplateRequest: V1UpdateRoleTemplateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RoleTemplate>> => {
  return axios.default.post(
    `/agora.v1.RBACService/UpdateRoleTemplate`,
    v1UpdateRoleTemplateRequest,
    options,
  );
};

export const getUpdateRoleTemplateMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRoleTemplate>>,
    TError,
    { data: V1UpdateRoleTemplateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRoleTemplate>>,
  TError,
  { data: V1UpdateRoleTemplateRequest },
  TContext
> => {
  const mutationKey = ['updateRoleTemplate'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRoleTemplate>>,
    { data: V1UpdateRoleTemplateRequest }
  > = props => {
    const { data } = props ?? {};

    return updateRoleTemplate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRoleTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRoleTemplate>>
>;
export type UpdateRoleTemplateMutationBody = V1UpdateRoleTemplateRequest;
export type UpdateRoleTemplateMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a role template.
 */
export const useUpdateRoleTemplate = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRoleTemplate>>,
      TError,
      { data: V1UpdateRoleTemplateRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateRoleTemplate>>,
  TError,
  { data: V1UpdateRoleTemplateRequest },
  TContext
> => {
  const mutationOptions = getUpdateRoleTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists all pending invitations addressed to the current authenticated user, (MAN-3388)
grouped by inviting organization. Powers the "Pending invitations" section
on the user profile page. Repo-side query: `user_invitations WHERE
user_email = <current user> AND invitation_status = 'sent' AND direction =
'invite'`, joined to org for the display name.
 */
export const listCurrentUserPendingInvitations = (
  params?: ListCurrentUserPendingInvitationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListCurrentUserPendingInvitationsResponse>> => {
  return axios.default.get(`/api/v1/me/invitations`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListCurrentUserPendingInvitationsQueryKey = (
  params?: ListCurrentUserPendingInvitationsParams,
) => {
  return [`/api/v1/me/invitations`, ...(params ? [params] : [])] as const;
};

export const getListCurrentUserPendingInvitationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: ListCurrentUserPendingInvitationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCurrentUserPendingInvitationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>
  > = ({ signal }) =>
    listCurrentUserPendingInvitations(params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCurrentUserPendingInvitationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>
>;
export type ListCurrentUserPendingInvitationsQueryError = AxiosError<RpcStatus>;

export function useListCurrentUserPendingInvitations<
  TData = Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
  TError = AxiosError<RpcStatus>,
>(
  params: undefined | ListCurrentUserPendingInvitationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
          TError,
          Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCurrentUserPendingInvitations<
  TData = Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: ListCurrentUserPendingInvitationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
          TError,
          Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCurrentUserPendingInvitations<
  TData = Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: ListCurrentUserPendingInvitationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all pending invitations addressed to the current authenticated user, (MAN-3388)
grouped by inviting organization. Powers the "Pending invitations" section
on the user profile page. Repo-side query: `user_invitations WHERE
user_email = <current user> AND invitation_status = 'sent' AND direction =
'invite'`, joined to org for the display name.
 */

export function useListCurrentUserPendingInvitations<
  TData = Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: ListCurrentUserPendingInvitationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCurrentUserPendingInvitations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListCurrentUserPendingInvitationsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns the current authenticated user's permissions in an organization.
 */
export const currentUserOrganizationPermissions = (
  organization: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CurrentUserOrganizationPermissionsResponse>> => {
  return axios.default.get(
    `/api/v1/me/organizations/${organization}/permissions`,
    options,
  );
};

export const getCurrentUserOrganizationPermissionsQueryKey = (
  organization?: string,
) => {
  return [`/api/v1/me/organizations/${organization}/permissions`] as const;
};

export const getCurrentUserOrganizationPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCurrentUserOrganizationPermissionsQueryKey(organization);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof currentUserOrganizationPermissions>>
  > = ({ signal }) =>
    currentUserOrganizationPermissions(organization, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CurrentUserOrganizationPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof currentUserOrganizationPermissions>>
>;
export type CurrentUserOrganizationPermissionsQueryError =
  AxiosError<RpcStatus>;

export function useCurrentUserOrganizationPermissions<
  TData = Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
          TError,
          Awaited<ReturnType<typeof currentUserOrganizationPermissions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserOrganizationPermissions<
  TData = Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
          TError,
          Awaited<ReturnType<typeof currentUserOrganizationPermissions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserOrganizationPermissions<
  TData = Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the current authenticated user's permissions in an organization.
 */

export function useCurrentUserOrganizationPermissions<
  TData = Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationPermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCurrentUserOrganizationPermissionsQueryOptions(
    organization,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns the current authenticated user's roles in an organization.
 */
export const currentUserOrganizationRoles = (
  organization: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CurrentUserOrganizationRolesResponse>> => {
  return axios.default.get(
    `/api/v1/me/organizations/${organization}/roles`,
    options,
  );
};

export const getCurrentUserOrganizationRolesQueryKey = (
  organization?: string,
) => {
  return [`/api/v1/me/organizations/${organization}/roles`] as const;
};

export const getCurrentUserOrganizationRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCurrentUserOrganizationRolesQueryKey(organization);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof currentUserOrganizationRoles>>
  > = ({ signal }) =>
    currentUserOrganizationRoles(organization, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CurrentUserOrganizationRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof currentUserOrganizationRoles>>
>;
export type CurrentUserOrganizationRolesQueryError = AxiosError<RpcStatus>;

export function useCurrentUserOrganizationRoles<
  TData = Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof currentUserOrganizationRoles>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserOrganizationRoles<
  TData = Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof currentUserOrganizationRoles>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserOrganizationRoles<
  TData = Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the current authenticated user's roles in an organization.
 */

export function useCurrentUserOrganizationRoles<
  TData = Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCurrentUserOrganizationRolesQueryOptions(
    organization,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns the current authenticated user's permissions in a workspace.
 */
export const currentUserWorkspacePermissions = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CurrentUserWorkspacePermissionsResponse>> => {
  return axios.default.get(
    `/api/v1/me/organizations/${organization}/workspaces/${workspace}/permissions`,
    options,
  );
};

export const getCurrentUserWorkspacePermissionsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/me/organizations/${organization}/workspaces/${workspace}/permissions`,
  ] as const;
};

export const getCurrentUserWorkspacePermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCurrentUserWorkspacePermissionsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof currentUserWorkspacePermissions>>
  > = ({ signal }) =>
    currentUserWorkspacePermissions(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CurrentUserWorkspacePermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof currentUserWorkspacePermissions>>
>;
export type CurrentUserWorkspacePermissionsQueryError = AxiosError<RpcStatus>;

export function useCurrentUserWorkspacePermissions<
  TData = Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
          TError,
          Awaited<ReturnType<typeof currentUserWorkspacePermissions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserWorkspacePermissions<
  TData = Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
          TError,
          Awaited<ReturnType<typeof currentUserWorkspacePermissions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserWorkspacePermissions<
  TData = Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the current authenticated user's permissions in a workspace.
 */

export function useCurrentUserWorkspacePermissions<
  TData = Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserWorkspacePermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCurrentUserWorkspacePermissionsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns the current authenticated user's roles in a workspace.
 */
export const currentUserWorkspaceRoles = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CurrentUserWorkspaceRolesResponse>> => {
  return axios.default.get(
    `/api/v1/me/organizations/${organization}/workspaces/${workspace}/roles`,
    options,
  );
};

export const getCurrentUserWorkspaceRolesQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/me/organizations/${organization}/workspaces/${workspace}/roles`,
  ] as const;
};

export const getCurrentUserWorkspaceRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCurrentUserWorkspaceRolesQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof currentUserWorkspaceRoles>>
  > = ({ signal }) =>
    currentUserWorkspaceRoles(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CurrentUserWorkspaceRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof currentUserWorkspaceRoles>>
>;
export type CurrentUserWorkspaceRolesQueryError = AxiosError<RpcStatus>;

export function useCurrentUserWorkspaceRoles<
  TData = Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
          TError,
          Awaited<ReturnType<typeof currentUserWorkspaceRoles>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserWorkspaceRoles<
  TData = Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
          TError,
          Awaited<ReturnType<typeof currentUserWorkspaceRoles>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserWorkspaceRoles<
  TData = Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the current authenticated user's roles in a workspace.
 */

export function useCurrentUserWorkspaceRoles<
  TData = Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserWorkspaceRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCurrentUserWorkspaceRolesQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Supported filter fields:
  organization — resource name: organizations/{organization}
  workspace    — resource name: organizations/{organization}/workspaces/{workspace}

Filter examples:
  filter="organization=organizations/org_abc"
  filter="workspace=organizations/org_abc/workspaces/ws_xyz"
  filter="organization=organizations/org_abc AND workspace=organizations/org_abc/workspaces/ws_xyz"

Semantics:
  - If `organization` is set, the response includes permissions granted by
    the user's org-level role in that organization.
  - If `workspace` is set, the response includes permissions granted by the
    user's workspace-level role in that workspace.
  - If both are set, the response is the union across both scopes.
  - If the filter is empty, the response is the union of all permissions
    the user holds across every organization and workspace they belong to.

Only the `=` operator is supported on `organization` and `workspace` fields.
Any other filter field or operator results in INVALID_ARGUMENT.
 * @summary Returns the authenticated user's permissions, optionally filtered by
organization and/or workspace using AIP-160 syntax.
 */
export const currentUserPermissions = (
  params?: CurrentUserPermissionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CurrentUserPermissionsResponse>> => {
  return axios.default.get(`/api/v1/me/permissions`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getCurrentUserPermissionsQueryKey = (
  params?: CurrentUserPermissionsParams,
) => {
  return [`/api/v1/me/permissions`, ...(params ? [params] : [])] as const;
};

export const getCurrentUserPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof currentUserPermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: CurrentUserPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserPermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCurrentUserPermissionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof currentUserPermissions>>
  > = ({ signal }) =>
    currentUserPermissions(params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof currentUserPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CurrentUserPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof currentUserPermissions>>
>;
export type CurrentUserPermissionsQueryError = AxiosError<RpcStatus>;

export function useCurrentUserPermissions<
  TData = Awaited<ReturnType<typeof currentUserPermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  params: undefined | CurrentUserPermissionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserPermissions>>,
          TError,
          Awaited<ReturnType<typeof currentUserPermissions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserPermissions<
  TData = Awaited<ReturnType<typeof currentUserPermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: CurrentUserPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserPermissions>>,
          TError,
          Awaited<ReturnType<typeof currentUserPermissions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserPermissions<
  TData = Awaited<ReturnType<typeof currentUserPermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: CurrentUserPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserPermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the authenticated user's permissions, optionally filtered by
organization and/or workspace using AIP-160 syntax.
 */

export function useCurrentUserPermissions<
  TData = Awaited<ReturnType<typeof currentUserPermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: CurrentUserPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserPermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCurrentUserPermissionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates an access-request invitation for the current user on an (MAN-3393)
organization they do not currently have access to. Idempotent: if a
pending request already exists from the same user for the same org, the
existing invitation is returned. Notifies org admins via Herald.
 */
export const requestOrganizationAccess = (
  organization: string,
  rBACServiceRequestOrganizationAccessBody: RBACServiceRequestOrganizationAccessBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Invitation>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/access:request`,
    rBACServiceRequestOrganizationAccessBody,
    options,
  );
};

export const getRequestOrganizationAccessMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestOrganizationAccess>>,
    TError,
    { organization: string; data: RBACServiceRequestOrganizationAccessBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestOrganizationAccess>>,
  TError,
  { organization: string; data: RBACServiceRequestOrganizationAccessBody },
  TContext
> => {
  const mutationKey = ['requestOrganizationAccess'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestOrganizationAccess>>,
    { organization: string; data: RBACServiceRequestOrganizationAccessBody }
  > = props => {
    const { organization, data } = props ?? {};

    return requestOrganizationAccess(organization, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestOrganizationAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestOrganizationAccess>>
>;
export type RequestOrganizationAccessMutationBody =
  RBACServiceRequestOrganizationAccessBody;
export type RequestOrganizationAccessMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates an access-request invitation for the current user on an (MAN-3393)
organization they do not currently have access to. Idempotent: if a
pending request already exists from the same user for the same org, the
existing invitation is returned. Notifies org admins via Herald.
 */
export const useRequestOrganizationAccess = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestOrganizationAccess>>,
      TError,
      { organization: string; data: RBACServiceRequestOrganizationAccessBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof requestOrganizationAccess>>,
  TError,
  { organization: string; data: RBACServiceRequestOrganizationAccessBody },
  TContext
> => {
  const mutationOptions = getRequestOrganizationAccessMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets invitation details by ID.
 */
export const getInvitation = (
  organization: string,
  invitation: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Invitation>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/invitations/${invitation}`,
    options,
  );
};

export const getGetInvitationQueryKey = (
  organization?: string,
  invitation?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/invitations/${invitation}`,
  ] as const;
};

export const getGetInvitationQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvitation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  invitation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInvitationQueryKey(organization, invitation);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitation>>> = ({
    signal,
  }) => getInvitation(organization, invitation, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && invitation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvitation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInvitationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvitation>>
>;
export type GetInvitationQueryError = AxiosError<RpcStatus>;

export function useGetInvitation<
  TData = Awaited<ReturnType<typeof getInvitation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  invitation: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitation>>,
          TError,
          Awaited<ReturnType<typeof getInvitation>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInvitation<
  TData = Awaited<ReturnType<typeof getInvitation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  invitation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitation>>,
          TError,
          Awaited<ReturnType<typeof getInvitation>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInvitation<
  TData = Awaited<ReturnType<typeof getInvitation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  invitation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets invitation details by ID.
 */

export function useGetInvitation<
  TData = Awaited<ReturnType<typeof getInvitation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  invitation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetInvitationQueryOptions(
    organization,
    invitation,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Accepts an invitation, adding the user to the organization/workspace.
 */
export const acceptInvitation = (
  organization: string,
  invitation: string,
  rBACServiceAcceptInvitationBody: RBACServiceAcceptInvitationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AcceptInvitationResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/invitations/${invitation}:accept`,
    rBACServiceAcceptInvitationBody,
    options,
  );
};

export const getAcceptInvitationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvitation>>,
    TError,
    {
      organization: string;
      invitation: string;
      data: RBACServiceAcceptInvitationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptInvitation>>,
  TError,
  {
    organization: string;
    invitation: string;
    data: RBACServiceAcceptInvitationBody;
  },
  TContext
> => {
  const mutationKey = ['acceptInvitation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptInvitation>>,
    {
      organization: string;
      invitation: string;
      data: RBACServiceAcceptInvitationBody;
    }
  > = props => {
    const { organization, invitation, data } = props ?? {};

    return acceptInvitation(organization, invitation, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptInvitation>>
>;
export type AcceptInvitationMutationBody = RBACServiceAcceptInvitationBody;
export type AcceptInvitationMutationError = AxiosError<RpcStatus>;

/**
 * @summary Accepts an invitation, adding the user to the organization/workspace.
 */
export const useAcceptInvitation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acceptInvitation>>,
      TError,
      {
        organization: string;
        invitation: string;
        data: RBACServiceAcceptInvitationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acceptInvitation>>,
  TError,
  {
    organization: string;
    invitation: string;
    data: RBACServiceAcceptInvitationBody;
  },
  TContext
> => {
  const mutationOptions = getAcceptInvitationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Unlike `AcceptInvitation` (invitee-side, email-match auth), this RPC
is admin-only and requires the caller to hold the `users.assign`
permission on the org or workspace scope of the request. Role
templates passed here must match the request's scope (org-scoped
templates for org requests, workspace-scoped for workspace
requests). (MAN-3617)
 * @summary Admin-side approval for a Request-direction invitation produced by
`RequestOrganizationAccess` / `RequestWorkspaceAccess`. The admin
chooses the role(s) to grant the requester at approval time —
mirroring the GitHub / Google / Atlassian pattern (the requester
says "let me in," the admin says "as what").
 */
export const approveAccessRequest = (
  organization: string,
  invitation: string,
  rBACServiceApproveAccessRequestBody: RBACServiceApproveAccessRequestBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Invitation>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/invitations/${invitation}:approveAccess`,
    rBACServiceApproveAccessRequestBody,
    options,
  );
};

export const getApproveAccessRequestMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveAccessRequest>>,
    TError,
    {
      organization: string;
      invitation: string;
      data: RBACServiceApproveAccessRequestBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveAccessRequest>>,
  TError,
  {
    organization: string;
    invitation: string;
    data: RBACServiceApproveAccessRequestBody;
  },
  TContext
> => {
  const mutationKey = ['approveAccessRequest'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveAccessRequest>>,
    {
      organization: string;
      invitation: string;
      data: RBACServiceApproveAccessRequestBody;
    }
  > = props => {
    const { organization, invitation, data } = props ?? {};

    return approveAccessRequest(organization, invitation, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveAccessRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveAccessRequest>>
>;
export type ApproveAccessRequestMutationBody =
  RBACServiceApproveAccessRequestBody;
export type ApproveAccessRequestMutationError = AxiosError<RpcStatus>;

/**
 * @summary Admin-side approval for a Request-direction invitation produced by
`RequestOrganizationAccess` / `RequestWorkspaceAccess`. The admin
chooses the role(s) to grant the requester at approval time —
mirroring the GitHub / Google / Atlassian pattern (the requester
says "let me in," the admin says "as what").
 */
export const useApproveAccessRequest = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveAccessRequest>>,
      TError,
      {
        organization: string;
        invitation: string;
        data: RBACServiceApproveAccessRequestBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveAccessRequest>>,
  TError,
  {
    organization: string;
    invitation: string;
    data: RBACServiceApproveAccessRequestBody;
  },
  TContext
> => {
  const mutationOptions = getApproveAccessRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Marks an invitation as declined by the invitee. (MAN-3388)
Distinct from `RevokeOrganizationUserInvite` / `RevokeWorkspaceUserInvite`
(which are inviter-side actions). The server verifies the caller owns the
invitation by email match before updating status to `DECLINED`.
 */
export const declineInvitation = (
  organization: string,
  invitation: string,
  rBACServiceDeclineInvitationBody: RBACServiceDeclineInvitationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Invitation>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/invitations/${invitation}:decline`,
    rBACServiceDeclineInvitationBody,
    options,
  );
};

export const getDeclineInvitationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof declineInvitation>>,
    TError,
    {
      organization: string;
      invitation: string;
      data: RBACServiceDeclineInvitationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof declineInvitation>>,
  TError,
  {
    organization: string;
    invitation: string;
    data: RBACServiceDeclineInvitationBody;
  },
  TContext
> => {
  const mutationKey = ['declineInvitation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof declineInvitation>>,
    {
      organization: string;
      invitation: string;
      data: RBACServiceDeclineInvitationBody;
    }
  > = props => {
    const { organization, invitation, data } = props ?? {};

    return declineInvitation(organization, invitation, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeclineInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof declineInvitation>>
>;
export type DeclineInvitationMutationBody = RBACServiceDeclineInvitationBody;
export type DeclineInvitationMutationError = AxiosError<RpcStatus>;

/**
 * @summary Marks an invitation as declined by the invitee. (MAN-3388)
Distinct from `RevokeOrganizationUserInvite` / `RevokeWorkspaceUserInvite`
(which are inviter-side actions). The server verifies the caller owns the
invitation by email match before updating status to `DECLINED`.
 */
export const useDeclineInvitation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof declineInvitation>>,
      TError,
      {
        organization: string;
        invitation: string;
        data: RBACServiceDeclineInvitationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof declineInvitation>>,
  TError,
  {
    organization: string;
    invitation: string;
    data: RBACServiceDeclineInvitationBody;
  },
  TContext
> => {
  const mutationOptions = getDeclineInvitationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Admin-side denial of a Request-direction invitation produced by
`RequestOrganizationAccess` / `RequestWorkspaceAccess`. The sibling
of `ApproveAccessRequest` — flips the row to `REVOKED` and emails
the requester. Semantically distinct from `RevokeOrganizationUserInvite`
/ `RevokeWorkspaceUserInvite` (which are admin-on-their-own-invite,
not admin-on-someone-else's-request) and carries an optional
free-form `reason` surfaced in the rejection email. (MAN-3618)
 */
export const denyAccessRequest = (
  organization: string,
  invitation: string,
  rBACServiceDenyAccessRequestBody: RBACServiceDenyAccessRequestBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DenyAccessRequestResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/invitations/${invitation}:denyAccess`,
    rBACServiceDenyAccessRequestBody,
    options,
  );
};

export const getDenyAccessRequestMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof denyAccessRequest>>,
    TError,
    {
      organization: string;
      invitation: string;
      data: RBACServiceDenyAccessRequestBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof denyAccessRequest>>,
  TError,
  {
    organization: string;
    invitation: string;
    data: RBACServiceDenyAccessRequestBody;
  },
  TContext
> => {
  const mutationKey = ['denyAccessRequest'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof denyAccessRequest>>,
    {
      organization: string;
      invitation: string;
      data: RBACServiceDenyAccessRequestBody;
    }
  > = props => {
    const { organization, invitation, data } = props ?? {};

    return denyAccessRequest(organization, invitation, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DenyAccessRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof denyAccessRequest>>
>;
export type DenyAccessRequestMutationBody = RBACServiceDenyAccessRequestBody;
export type DenyAccessRequestMutationError = AxiosError<RpcStatus>;

/**
 * @summary Admin-side denial of a Request-direction invitation produced by
`RequestOrganizationAccess` / `RequestWorkspaceAccess`. The sibling
of `ApproveAccessRequest` — flips the row to `REVOKED` and emails
the requester. Semantically distinct from `RevokeOrganizationUserInvite`
/ `RevokeWorkspaceUserInvite` (which are admin-on-their-own-invite,
not admin-on-someone-else's-request) and carries an optional
free-form `reason` surfaced in the rejection email. (MAN-3618)
 */
export const useDenyAccessRequest = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof denyAccessRequest>>,
      TError,
      {
        organization: string;
        invitation: string;
        data: RBACServiceDenyAccessRequestBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof denyAccessRequest>>,
  TError,
  {
    organization: string;
    invitation: string;
    data: RBACServiceDenyAccessRequestBody;
  },
  TContext
> => {
  const mutationOptions = getDenyAccessRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Revokes a pending organization user invitation.
 */
export const revokeOrganizationUserInvite = (
  organization: string,
  invitation: string,
  rBACServiceRevokeOrganizationUserInviteBody: RBACServiceRevokeOrganizationUserInviteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RevokeOrganizationUserInviteResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/invitations/${invitation}:revoke`,
    rBACServiceRevokeOrganizationUserInviteBody,
    options,
  );
};

export const getRevokeOrganizationUserInviteMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeOrganizationUserInvite>>,
    TError,
    {
      organization: string;
      invitation: string;
      data: RBACServiceRevokeOrganizationUserInviteBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeOrganizationUserInvite>>,
  TError,
  {
    organization: string;
    invitation: string;
    data: RBACServiceRevokeOrganizationUserInviteBody;
  },
  TContext
> => {
  const mutationKey = ['revokeOrganizationUserInvite'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeOrganizationUserInvite>>,
    {
      organization: string;
      invitation: string;
      data: RBACServiceRevokeOrganizationUserInviteBody;
    }
  > = props => {
    const { organization, invitation, data } = props ?? {};

    return revokeOrganizationUserInvite(
      organization,
      invitation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeOrganizationUserInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeOrganizationUserInvite>>
>;
export type RevokeOrganizationUserInviteMutationBody =
  RBACServiceRevokeOrganizationUserInviteBody;
export type RevokeOrganizationUserInviteMutationError = AxiosError<RpcStatus>;

/**
 * @summary Revokes a pending organization user invitation.
 */
export const useRevokeOrganizationUserInvite = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revokeOrganizationUserInvite>>,
      TError,
      {
        organization: string;
        invitation: string;
        data: RBACServiceRevokeOrganizationUserInviteBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof revokeOrganizationUserInvite>>,
  TError,
  {
    organization: string;
    invitation: string;
    data: RBACServiceRevokeOrganizationUserInviteBody;
  },
  TContext
> => {
  const mutationOptions =
    getRevokeOrganizationUserInviteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists pending user invitations for an organization.
 */
export const listOrganizationUserInvites = (
  organization: string,
  params?: ListOrganizationUserInvitesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListOrganizationUserInvitesResponse>> => {
  return axios.default.get(`/api/v1/organizations/${organization}/invites`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListOrganizationUserInvitesQueryKey = (
  organization?: string,
  params?: ListOrganizationUserInvitesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/invites`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListOrganizationUserInvitesQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrganizationUserInvites>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUserInvitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUserInvites>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOrganizationUserInvitesQueryKey(organization, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganizationUserInvites>>
  > = ({ signal }) =>
    listOrganizationUserInvites(organization, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrganizationUserInvites>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationUserInvitesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganizationUserInvites>>
>;
export type ListOrganizationUserInvitesQueryError = AxiosError<RpcStatus>;

export function useListOrganizationUserInvites<
  TData = Awaited<ReturnType<typeof listOrganizationUserInvites>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params: undefined | ListOrganizationUserInvitesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUserInvites>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationUserInvites>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationUserInvites>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationUserInvites<
  TData = Awaited<ReturnType<typeof listOrganizationUserInvites>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUserInvitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUserInvites>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationUserInvites>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationUserInvites>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationUserInvites<
  TData = Awaited<ReturnType<typeof listOrganizationUserInvites>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUserInvitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUserInvites>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists pending user invitations for an organization.
 */

export function useListOrganizationUserInvites<
  TData = Awaited<ReturnType<typeof listOrganizationUserInvites>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUserInvitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUserInvites>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOrganizationUserInvitesQueryOptions(
    organization,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists all available roles in an organization.
 */
export const listOrganizationRoles = (
  organization: string,
  params?: ListOrganizationRolesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListOrganizationRolesResponse>> => {
  return axios.default.get(`/api/v1/organizations/${organization}/roles`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListOrganizationRolesQueryKey = (
  organization?: string,
  params?: ListOrganizationRolesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/roles`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListOrganizationRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrganizationRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOrganizationRolesQueryKey(organization, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganizationRoles>>
  > = ({ signal }) =>
    listOrganizationRoles(organization, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrganizationRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganizationRoles>>
>;
export type ListOrganizationRolesQueryError = AxiosError<RpcStatus>;

export function useListOrganizationRoles<
  TData = Awaited<ReturnType<typeof listOrganizationRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params: undefined | ListOrganizationRolesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationRoles>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationRoles<
  TData = Awaited<ReturnType<typeof listOrganizationRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationRoles>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationRoles<
  TData = Awaited<ReturnType<typeof listOrganizationRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all available roles in an organization.
 */

export function useListOrganizationRoles<
  TData = Awaited<ReturnType<typeof listOrganizationRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOrganizationRolesQueryOptions(
    organization,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Assigns roles to a single user in an organization.
This replaces all existing roles for the user in this organization.
 */
export const assignOrganizationUserRoles = (
  organization: string,
  user: string,
  rBACServiceAssignOrganizationUserRolesBody: RBACServiceAssignOrganizationUserRolesBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AssignOrganizationUserRolesResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/users/${user}:assignRoles`,
    rBACServiceAssignOrganizationUserRolesBody,
    options,
  );
};

export const getAssignOrganizationUserRolesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignOrganizationUserRoles>>,
    TError,
    {
      organization: string;
      user: string;
      data: RBACServiceAssignOrganizationUserRolesBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignOrganizationUserRoles>>,
  TError,
  {
    organization: string;
    user: string;
    data: RBACServiceAssignOrganizationUserRolesBody;
  },
  TContext
> => {
  const mutationKey = ['assignOrganizationUserRoles'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignOrganizationUserRoles>>,
    {
      organization: string;
      user: string;
      data: RBACServiceAssignOrganizationUserRolesBody;
    }
  > = props => {
    const { organization, user, data } = props ?? {};

    return assignOrganizationUserRoles(organization, user, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignOrganizationUserRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignOrganizationUserRoles>>
>;
export type AssignOrganizationUserRolesMutationBody =
  RBACServiceAssignOrganizationUserRolesBody;
export type AssignOrganizationUserRolesMutationError = AxiosError<RpcStatus>;

/**
 * @summary Assigns roles to a single user in an organization.
This replaces all existing roles for the user in this organization.
 */
export const useAssignOrganizationUserRoles = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignOrganizationUserRoles>>,
      TError,
      {
        organization: string;
        user: string;
        data: RBACServiceAssignOrganizationUserRolesBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof assignOrganizationUserRoles>>,
  TError,
  {
    organization: string;
    user: string;
    data: RBACServiceAssignOrganizationUserRolesBody;
  },
  TContext
> => {
  const mutationOptions =
    getAssignOrganizationUserRolesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Invites users to an organization with specified roles.
The caller's user_id is extracted from the authentication token.
 */
export const inviteOrganizationUsers = (
  organization: string,
  rBACServiceInviteOrganizationUsersBody: RBACServiceInviteOrganizationUsersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1InviteOrganizationUsersResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/users:invite`,
    rBACServiceInviteOrganizationUsersBody,
    options,
  );
};

export const getInviteOrganizationUsersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteOrganizationUsers>>,
    TError,
    { organization: string; data: RBACServiceInviteOrganizationUsersBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteOrganizationUsers>>,
  TError,
  { organization: string; data: RBACServiceInviteOrganizationUsersBody },
  TContext
> => {
  const mutationKey = ['inviteOrganizationUsers'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteOrganizationUsers>>,
    { organization: string; data: RBACServiceInviteOrganizationUsersBody }
  > = props => {
    const { organization, data } = props ?? {};

    return inviteOrganizationUsers(organization, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteOrganizationUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteOrganizationUsers>>
>;
export type InviteOrganizationUsersMutationBody =
  RBACServiceInviteOrganizationUsersBody;
export type InviteOrganizationUsersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Invites users to an organization with specified roles.
The caller's user_id is extracted from the authentication token.
 */
export const useInviteOrganizationUsers = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof inviteOrganizationUsers>>,
      TError,
      { organization: string; data: RBACServiceInviteOrganizationUsersBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof inviteOrganizationUsers>>,
  TError,
  { organization: string; data: RBACServiceInviteOrganizationUsersBody },
  TContext
> => {
  const mutationOptions = getInviteOrganizationUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Removes users from an organization.
This also removes the users from all workspaces within the organization.
 */
export const removeOrganizationUsers = (
  organization: string,
  rBACServiceRemoveOrganizationUsersBody: RBACServiceRemoveOrganizationUsersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RemoveOrganizationUsersResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/users:remove`,
    rBACServiceRemoveOrganizationUsersBody,
    options,
  );
};

export const getRemoveOrganizationUsersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeOrganizationUsers>>,
    TError,
    { organization: string; data: RBACServiceRemoveOrganizationUsersBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeOrganizationUsers>>,
  TError,
  { organization: string; data: RBACServiceRemoveOrganizationUsersBody },
  TContext
> => {
  const mutationKey = ['removeOrganizationUsers'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeOrganizationUsers>>,
    { organization: string; data: RBACServiceRemoveOrganizationUsersBody }
  > = props => {
    const { organization, data } = props ?? {};

    return removeOrganizationUsers(organization, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveOrganizationUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeOrganizationUsers>>
>;
export type RemoveOrganizationUsersMutationBody =
  RBACServiceRemoveOrganizationUsersBody;
export type RemoveOrganizationUsersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Removes users from an organization.
This also removes the users from all workspaces within the organization.
 */
export const useRemoveOrganizationUsers = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeOrganizationUsers>>,
      TError,
      { organization: string; data: RBACServiceRemoveOrganizationUsersBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeOrganizationUsers>>,
  TError,
  { organization: string; data: RBACServiceRemoveOrganizationUsersBody },
  TContext
> => {
  const mutationOptions = getRemoveOrganizationUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Workspace-scoped analogue of `RequestOrganizationAccess`. (MAN-3393)
 */
export const requestWorkspaceAccess = (
  organization: string,
  workspace: string,
  rBACServiceRequestWorkspaceAccessBody: RBACServiceRequestWorkspaceAccessBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Invitation>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/access:request`,
    rBACServiceRequestWorkspaceAccessBody,
    options,
  );
};

export const getRequestWorkspaceAccessMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestWorkspaceAccess>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: RBACServiceRequestWorkspaceAccessBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestWorkspaceAccess>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: RBACServiceRequestWorkspaceAccessBody;
  },
  TContext
> => {
  const mutationKey = ['requestWorkspaceAccess'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestWorkspaceAccess>>,
    {
      organization: string;
      workspace: string;
      data: RBACServiceRequestWorkspaceAccessBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return requestWorkspaceAccess(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestWorkspaceAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestWorkspaceAccess>>
>;
export type RequestWorkspaceAccessMutationBody =
  RBACServiceRequestWorkspaceAccessBody;
export type RequestWorkspaceAccessMutationError = AxiosError<RpcStatus>;

/**
 * @summary Workspace-scoped analogue of `RequestOrganizationAccess`. (MAN-3393)
 */
export const useRequestWorkspaceAccess = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestWorkspaceAccess>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: RBACServiceRequestWorkspaceAccessBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof requestWorkspaceAccess>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: RBACServiceRequestWorkspaceAccessBody;
  },
  TContext
> => {
  const mutationOptions = getRequestWorkspaceAccessMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists the custom roles defined in a workspace.
 */
export const listCustomRoles = (
  organization: string,
  workspace: string,
  params?: ListCustomRolesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListCustomRolesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/customRoles`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListCustomRolesQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListCustomRolesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/customRoles`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListCustomRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListCustomRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCustomRolesQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomRoles>>> = ({
    signal,
  }) =>
    listCustomRoles(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCustomRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomRoles>>
>;
export type ListCustomRolesQueryError = AxiosError<RpcStatus>;

export function useListCustomRoles<
  TData = Awaited<ReturnType<typeof listCustomRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListCustomRolesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomRoles>>,
          TError,
          Awaited<ReturnType<typeof listCustomRoles>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCustomRoles<
  TData = Awaited<ReturnType<typeof listCustomRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListCustomRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomRoles>>,
          TError,
          Awaited<ReturnType<typeof listCustomRoles>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCustomRoles<
  TData = Awaited<ReturnType<typeof listCustomRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListCustomRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists the custom roles defined in a workspace.
 */

export function useListCustomRoles<
  TData = Awaited<ReturnType<typeof listCustomRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListCustomRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListCustomRolesQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a custom role scoped to a workspace within an organization.
Every granted permission template must be workspace-scoped.
 */
export const createCustomRole = (
  organization: string,
  workspace: string,
  v1CustomRole: NonReadonly<V1CustomRole>,
  params?: CreateCustomRoleParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CustomRole>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/customRoles`,
    v1CustomRole,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getCreateCustomRoleMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomRole>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: NonReadonly<V1CustomRole>;
      params?: CreateCustomRoleParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomRole>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: NonReadonly<V1CustomRole>;
    params?: CreateCustomRoleParams;
  },
  TContext
> => {
  const mutationKey = ['createCustomRole'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomRole>>,
    {
      organization: string;
      workspace: string;
      data: NonReadonly<V1CustomRole>;
      params?: CreateCustomRoleParams;
    }
  > = props => {
    const { organization, workspace, data, params } = props ?? {};

    return createCustomRole(
      organization,
      workspace,
      data,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomRole>>
>;
export type CreateCustomRoleMutationBody = NonReadonly<V1CustomRole>;
export type CreateCustomRoleMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a custom role scoped to a workspace within an organization.
Every granted permission template must be workspace-scoped.
 */
export const useCreateCustomRole = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCustomRole>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: NonReadonly<V1CustomRole>;
        params?: CreateCustomRoleParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCustomRole>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: NonReadonly<V1CustomRole>;
    params?: CreateCustomRoleParams;
  },
  TContext
> => {
  const mutationOptions = getCreateCustomRoleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets a custom role.
 */
export const getCustomRole = (
  organization: string,
  workspace: string,
  customRole: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CustomRole>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/customRoles/${customRole}`,
    options,
  );
};

export const getGetCustomRoleQueryKey = (
  organization?: string,
  workspace?: string,
  customRole?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/customRoles/${customRole}`,
  ] as const;
};

export const getGetCustomRoleQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomRole>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  customRole: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomRole>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomRoleQueryKey(organization, workspace, customRole);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomRole>>> = ({
    signal,
  }) =>
    getCustomRole(organization, workspace, customRole, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && customRole),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomRole>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCustomRoleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomRole>>
>;
export type GetCustomRoleQueryError = AxiosError<RpcStatus>;

export function useGetCustomRole<
  TData = Awaited<ReturnType<typeof getCustomRole>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  customRole: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomRole>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomRole>>,
          TError,
          Awaited<ReturnType<typeof getCustomRole>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomRole<
  TData = Awaited<ReturnType<typeof getCustomRole>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  customRole: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomRole>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomRole>>,
          TError,
          Awaited<ReturnType<typeof getCustomRole>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomRole<
  TData = Awaited<ReturnType<typeof getCustomRole>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  customRole: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomRole>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a custom role.
 */

export function useGetCustomRole<
  TData = Awaited<ReturnType<typeof getCustomRole>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  customRole: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomRole>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCustomRoleQueryOptions(
    organization,
    workspace,
    customRole,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes a custom role. Fails with FAILED_PRECONDITION while any user
still holds the role.
 */
export const deleteCustomRole = (
  organization: string,
  workspace: string,
  customRole: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteCustomRole200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/customRoles/${customRole}`,
    options,
  );
};

export const getDeleteCustomRoleMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomRole>>,
    TError,
    { organization: string; workspace: string; customRole: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomRole>>,
  TError,
  { organization: string; workspace: string; customRole: string },
  TContext
> => {
  const mutationKey = ['deleteCustomRole'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomRole>>,
    { organization: string; workspace: string; customRole: string }
  > = props => {
    const { organization, workspace, customRole } = props ?? {};

    return deleteCustomRole(organization, workspace, customRole, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomRole>>
>;

export type DeleteCustomRoleMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes a custom role. Fails with FAILED_PRECONDITION while any user
still holds the role.
 */
export const useDeleteCustomRole = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCustomRole>>,
      TError,
      { organization: string; workspace: string; customRole: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomRole>>,
  TError,
  { organization: string; workspace: string; customRole: string },
  TContext
> => {
  const mutationOptions = getDeleteCustomRoleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates a custom role. Permission changes take effect immediately for
every current holder of the role.
 */
export const updateCustomRole = (
  organization: string,
  workspace: string,
  customRole: string,
  updateCustomRoleBody: NonReadonly<UpdateCustomRoleBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CustomRole>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/customRoles/${customRole}`,
    updateCustomRoleBody,
    options,
  );
};

export const getUpdateCustomRoleMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomRole>>,
    TError,
    {
      organization: string;
      workspace: string;
      customRole: string;
      data: NonReadonly<UpdateCustomRoleBody>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCustomRole>>,
  TError,
  {
    organization: string;
    workspace: string;
    customRole: string;
    data: NonReadonly<UpdateCustomRoleBody>;
  },
  TContext
> => {
  const mutationKey = ['updateCustomRole'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCustomRole>>,
    {
      organization: string;
      workspace: string;
      customRole: string;
      data: NonReadonly<UpdateCustomRoleBody>;
    }
  > = props => {
    const { organization, workspace, customRole, data } = props ?? {};

    return updateCustomRole(
      organization,
      workspace,
      customRole,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCustomRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCustomRole>>
>;
export type UpdateCustomRoleMutationBody = NonReadonly<UpdateCustomRoleBody>;
export type UpdateCustomRoleMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a custom role. Permission changes take effect immediately for
every current holder of the role.
 */
export const useUpdateCustomRole = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCustomRole>>,
      TError,
      {
        organization: string;
        workspace: string;
        customRole: string;
        data: NonReadonly<UpdateCustomRoleBody>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCustomRole>>,
  TError,
  {
    organization: string;
    workspace: string;
    customRole: string;
    data: NonReadonly<UpdateCustomRoleBody>;
  },
  TContext
> => {
  const mutationOptions = getUpdateCustomRoleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Revokes a pending workspace user invitation.
 */
export const revokeWorkspaceUserInvite = (
  organization: string,
  workspace: string,
  invitation: string,
  rBACServiceRevokeWorkspaceUserInviteBody: RBACServiceRevokeWorkspaceUserInviteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RevokeWorkspaceUserInviteResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/invitations/${invitation}:revoke`,
    rBACServiceRevokeWorkspaceUserInviteBody,
    options,
  );
};

export const getRevokeWorkspaceUserInviteMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeWorkspaceUserInvite>>,
    TError,
    {
      organization: string;
      workspace: string;
      invitation: string;
      data: RBACServiceRevokeWorkspaceUserInviteBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeWorkspaceUserInvite>>,
  TError,
  {
    organization: string;
    workspace: string;
    invitation: string;
    data: RBACServiceRevokeWorkspaceUserInviteBody;
  },
  TContext
> => {
  const mutationKey = ['revokeWorkspaceUserInvite'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeWorkspaceUserInvite>>,
    {
      organization: string;
      workspace: string;
      invitation: string;
      data: RBACServiceRevokeWorkspaceUserInviteBody;
    }
  > = props => {
    const { organization, workspace, invitation, data } = props ?? {};

    return revokeWorkspaceUserInvite(
      organization,
      workspace,
      invitation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeWorkspaceUserInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeWorkspaceUserInvite>>
>;
export type RevokeWorkspaceUserInviteMutationBody =
  RBACServiceRevokeWorkspaceUserInviteBody;
export type RevokeWorkspaceUserInviteMutationError = AxiosError<RpcStatus>;

/**
 * @summary Revokes a pending workspace user invitation.
 */
export const useRevokeWorkspaceUserInvite = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revokeWorkspaceUserInvite>>,
      TError,
      {
        organization: string;
        workspace: string;
        invitation: string;
        data: RBACServiceRevokeWorkspaceUserInviteBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof revokeWorkspaceUserInvite>>,
  TError,
  {
    organization: string;
    workspace: string;
    invitation: string;
    data: RBACServiceRevokeWorkspaceUserInviteBody;
  },
  TContext
> => {
  const mutationOptions = getRevokeWorkspaceUserInviteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists pending user invitations for a workspace.
 */
export const listWorkspaceUserInvites = (
  organization: string,
  workspace: string,
  params?: ListWorkspaceUserInvitesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListWorkspaceUserInvitesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/invites`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListWorkspaceUserInvitesQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListWorkspaceUserInvitesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/invites`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListWorkspaceUserInvitesQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUserInvitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListWorkspaceUserInvitesQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceUserInvites>>
  > = ({ signal }) =>
    listWorkspaceUserInvites(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkspaceUserInvitesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceUserInvites>>
>;
export type ListWorkspaceUserInvitesQueryError = AxiosError<RpcStatus>;

export function useListWorkspaceUserInvites<
  TData = Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListWorkspaceUserInvitesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaceUserInvites>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaceUserInvites<
  TData = Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUserInvitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaceUserInvites>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaceUserInvites<
  TData = Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUserInvitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists pending user invitations for a workspace.
 */

export function useListWorkspaceUserInvites<
  TData = Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUserInvitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUserInvites>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListWorkspaceUserInvitesQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The client-facing counterpart to the internal ListPermissionTemplates: it
returns the same catalog with its display metadata, but omits the
PAT-allow-list fields (`pat_eligible`, the global schema version) so it
cannot be mistaken for an authorization input.

Only workspace-scoped permissions are returned, so every entry is valid
input to CreateCustomRole — a client never has to re-implement the
scope rule to avoid offering a choice the server rejects.

The result IS narrowed by the workspace's type: a permission declares which
WorkspaceTypes it applies to, and one that does not apply here is not
offered. A permission declaring none is UNCLASSIFIED and treated as
WORKSPACE_TYPE_REGULAR, so finance-style workspaces must opt in explicitly.

That makes this list a strict SUBSET of what CreateCustomRole accepts, not a
mirror of it: the validator checks workspace-scoping only, so it still
accepts a permission this endpoint hides. The direction that matters is
preserved — everything offered is accepted, so the picker never presents a
choice the server rejects — but do not infer the converse. Hiding a
permission here does NOT prevent it being granted, and does not stop an
already-granted one from authorizing.

The result is NOT narrowed to permissions the caller themselves holds. An
admin can therefore compose a role stronger than their own. If that should
change, it changes in the validator first and here second.

Returns the complete set in one response; see the paging fields on
ListWorkspacePermissionsRequest.
 * @summary Lists the permissions that can be granted within a workspace.
 */
export const listWorkspacePermissions = (
  organization: string,
  workspace: string,
  params?: ListWorkspacePermissionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListWorkspacePermissionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/permissions`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListWorkspacePermissionsQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListWorkspacePermissionsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/permissions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListWorkspacePermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspacePermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspacePermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspacePermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListWorkspacePermissionsQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspacePermissions>>
  > = ({ signal }) =>
    listWorkspacePermissions(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspacePermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkspacePermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspacePermissions>>
>;
export type ListWorkspacePermissionsQueryError = AxiosError<RpcStatus>;

export function useListWorkspacePermissions<
  TData = Awaited<ReturnType<typeof listWorkspacePermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListWorkspacePermissionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspacePermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspacePermissions>>,
          TError,
          Awaited<ReturnType<typeof listWorkspacePermissions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspacePermissions<
  TData = Awaited<ReturnType<typeof listWorkspacePermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspacePermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspacePermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspacePermissions>>,
          TError,
          Awaited<ReturnType<typeof listWorkspacePermissions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspacePermissions<
  TData = Awaited<ReturnType<typeof listWorkspacePermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspacePermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspacePermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists the permissions that can be granted within a workspace.
 */

export function useListWorkspacePermissions<
  TData = Awaited<ReturnType<typeof listWorkspacePermissions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspacePermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspacePermissions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListWorkspacePermissionsQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists all available roles in a workspace.
Returns both system-defined role templates and the workspace's own custom roles.
 */
export const listWorkspaceRoles = (
  organization: string,
  workspace: string,
  params?: ListWorkspaceRolesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListWorkspaceRolesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/roles`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListWorkspaceRolesQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListWorkspaceRolesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/roles`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListWorkspaceRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListWorkspaceRolesQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceRoles>>
  > = ({ signal }) =>
    listWorkspaceRoles(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkspaceRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceRoles>>
>;
export type ListWorkspaceRolesQueryError = AxiosError<RpcStatus>;

export function useListWorkspaceRoles<
  TData = Awaited<ReturnType<typeof listWorkspaceRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListWorkspaceRolesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaceRoles>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaceRoles>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaceRoles<
  TData = Awaited<ReturnType<typeof listWorkspaceRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaceRoles>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaceRoles>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaceRoles<
  TData = Awaited<ReturnType<typeof listWorkspaceRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all available roles in a workspace.
Returns both system-defined role templates and the workspace's own custom roles.
 */

export function useListWorkspaceRoles<
  TData = Awaited<ReturnType<typeof listWorkspaceRoles>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceRoles>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListWorkspaceRolesQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Assigns roles to a single user in a workspace.
This replaces all existing roles for the user in this workspace.
 */
export const assignWorkspaceUserRoles = (
  organization: string,
  workspace: string,
  user: string,
  rBACServiceAssignWorkspaceUserRolesBody: RBACServiceAssignWorkspaceUserRolesBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AssignWorkspaceUserRolesResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/users/${user}:assignRoles`,
    rBACServiceAssignWorkspaceUserRolesBody,
    options,
  );
};

export const getAssignWorkspaceUserRolesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignWorkspaceUserRoles>>,
    TError,
    {
      organization: string;
      workspace: string;
      user: string;
      data: RBACServiceAssignWorkspaceUserRolesBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignWorkspaceUserRoles>>,
  TError,
  {
    organization: string;
    workspace: string;
    user: string;
    data: RBACServiceAssignWorkspaceUserRolesBody;
  },
  TContext
> => {
  const mutationKey = ['assignWorkspaceUserRoles'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignWorkspaceUserRoles>>,
    {
      organization: string;
      workspace: string;
      user: string;
      data: RBACServiceAssignWorkspaceUserRolesBody;
    }
  > = props => {
    const { organization, workspace, user, data } = props ?? {};

    return assignWorkspaceUserRoles(
      organization,
      workspace,
      user,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignWorkspaceUserRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignWorkspaceUserRoles>>
>;
export type AssignWorkspaceUserRolesMutationBody =
  RBACServiceAssignWorkspaceUserRolesBody;
export type AssignWorkspaceUserRolesMutationError = AxiosError<RpcStatus>;

/**
 * @summary Assigns roles to a single user in a workspace.
This replaces all existing roles for the user in this workspace.
 */
export const useAssignWorkspaceUserRoles = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignWorkspaceUserRoles>>,
      TError,
      {
        organization: string;
        workspace: string;
        user: string;
        data: RBACServiceAssignWorkspaceUserRolesBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof assignWorkspaceUserRoles>>,
  TError,
  {
    organization: string;
    workspace: string;
    user: string;
    data: RBACServiceAssignWorkspaceUserRolesBody;
  },
  TContext
> => {
  const mutationOptions = getAssignWorkspaceUserRolesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Invites users to a workspace with specified roles.
Adding users to a workspace automatically adds them to the parent organization if not already members.
 */
export const inviteWorkspaceUsers = (
  organization: string,
  workspace: string,
  rBACServiceInviteWorkspaceUsersBody: RBACServiceInviteWorkspaceUsersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1InviteWorkspaceUsersResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/users:invite`,
    rBACServiceInviteWorkspaceUsersBody,
    options,
  );
};

export const getInviteWorkspaceUsersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteWorkspaceUsers>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: RBACServiceInviteWorkspaceUsersBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteWorkspaceUsers>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: RBACServiceInviteWorkspaceUsersBody;
  },
  TContext
> => {
  const mutationKey = ['inviteWorkspaceUsers'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteWorkspaceUsers>>,
    {
      organization: string;
      workspace: string;
      data: RBACServiceInviteWorkspaceUsersBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return inviteWorkspaceUsers(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteWorkspaceUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteWorkspaceUsers>>
>;
export type InviteWorkspaceUsersMutationBody =
  RBACServiceInviteWorkspaceUsersBody;
export type InviteWorkspaceUsersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Invites users to a workspace with specified roles.
Adding users to a workspace automatically adds them to the parent organization if not already members.
 */
export const useInviteWorkspaceUsers = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof inviteWorkspaceUsers>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: RBACServiceInviteWorkspaceUsersBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof inviteWorkspaceUsers>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: RBACServiceInviteWorkspaceUsersBody;
  },
  TContext
> => {
  const mutationOptions = getInviteWorkspaceUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Removes users from a workspace. Users remain in the parent organization.
 */
export const removeWorkspaceUsers = (
  organization: string,
  workspace: string,
  rBACServiceRemoveWorkspaceUsersBody: RBACServiceRemoveWorkspaceUsersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RemoveWorkspaceUsersResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/users:remove`,
    rBACServiceRemoveWorkspaceUsersBody,
    options,
  );
};

export const getRemoveWorkspaceUsersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeWorkspaceUsers>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: RBACServiceRemoveWorkspaceUsersBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeWorkspaceUsers>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: RBACServiceRemoveWorkspaceUsersBody;
  },
  TContext
> => {
  const mutationKey = ['removeWorkspaceUsers'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeWorkspaceUsers>>,
    {
      organization: string;
      workspace: string;
      data: RBACServiceRemoveWorkspaceUsersBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return removeWorkspaceUsers(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveWorkspaceUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeWorkspaceUsers>>
>;
export type RemoveWorkspaceUsersMutationBody =
  RBACServiceRemoveWorkspaceUsersBody;
export type RemoveWorkspaceUsersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Removes users from a workspace. Users remain in the parent organization.
 */
export const useRemoveWorkspaceUsers = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeWorkspaceUsers>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: RBACServiceRemoveWorkspaceUsersBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeWorkspaceUsers>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: RBACServiceRemoveWorkspaceUsersBody;
  },
  TContext
> => {
  const mutationOptions = getRemoveWorkspaceUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
